// import $ from 'jquery';


$(function () {

	$('.hamburger').click(function () {
		$(this).toggleClass('is-active');
		$('.header').toggleClass('hamburger-is-active');
		$('.internal-header').toggleClass('hamburger-is-active');
	});

});


// WEBPACK FOOTER //
// ./client/src/site__fus078/components/hamburger-button/index.js